import React from "react";
import ReactDOM from "react-dom";
import ActivityPopup from "../ReusableComponents/ActivityPopup";
import { GLOBAL_STYLES } from "../appConstants";

const Popup = {
  alert: (header, content, type, okCb, position, okBtnText, onClose, closeBtnText, successBtnSize =  GLOBAL_STYLES.FONT_SIZE_REGULAR) => {
    ReactDOM.render(
      <ActivityPopup
        header={header}
        content={content?.errorMessage || content?.message || content}
        position={position}
        type={type}
        okBtnText={okBtnText}
        closeBtnText={closeBtnText}
        onClickOk={() => {
          ReactDOM.unmountComponentAtNode(
            document.getElementById("modalHolder")
          );
          if (okCb) {
            okCb();
          }
        }}
        onClose={() => {
          ReactDOM.unmountComponentAtNode(
            document.getElementById("modalHolder")
          );
          if (onClose) {
            onClose();
          }
        }}
        successBtnSize={successBtnSize}
      />,
      document.getElementById("modalHolder")
    );
  },
};

export default Popup;
